import { z } from 'zod'

import { PHONE_REGEXP, REQUIRED_FIELD_MESSAGE } from '@/constants'

export const FORM_FIELDS = [
  {
    id: 1,
    placeholder: 'Имя объекта',
    name: 'description',
    required: true,
  },
  {
    id: 2,
    placeholder: 'Адрес',
    name: 'address',
    required: true,
  },
  {
    id: 3,
    placeholder: 'Имя владельца',
    name: 'ownerName',
    required: true,
  },
  {
    id: 4,
    placeholder: 'Телефон владельца',
    name: 'ownerPhoneNumber',
    required: true,
  },
]

export const constructionSiteCreationSchema = z.object({
  description: z.string().trim(),
  address: z.string().trim(),
  ownerName: z.string().trim(),
  ownerPhoneNumber: z
    .string({ required_error: REQUIRED_FIELD_MESSAGE })
    .trim()
    .min(1, REQUIRED_FIELD_MESSAGE)
    .regex(PHONE_REGEXP, {
      message: 'Неверный формат телефона',
    }),
})

export type ConstructionSiteCreationType = z.infer<
  typeof constructionSiteCreationSchema
>
